/**
 * Header tab defs sorted for DOM / jQuery UI tabs order (by index).
 * @param {Array<{ index?: number, tabId?: string }>|null|undefined} tabs
 * @returns {Array<{ index?: number, tabId?: string }>}
 */
export function tabSortedHeaderOrder(tabs) {
	if (!tabs || tabs.length === 0) {
		return [];
	}
	return tabs.slice().sort(function (a, b) {
		return (a.index || 0) - (b.index || 0);
	});
}

/**
 * First tab definition that represents real quote content (not the "new tab" placeholder).
 * @param {Array<{ index?: number, tabId?: string }>|null|undefined} tabDefs
 * @returns {{ index?: number, tabId?: string }|null}
 */
export function firstContentQuoteTab(tabDefs) {
	var sorted = tabSortedHeaderOrder(tabDefs);
	for (var i = 0; i < sorted.length; i++) {
		if (sorted[i].tabId && sorted[i].tabId !== "newtab") {
			return sorted[i];
		}
	}
	return sorted[0] || null;
}

/**
 * Index of a tab id within an already-sorted header list (for jQuery UI active index).
 * @param {Array<{ tabId?: string }>} sortedHeaders
 * @param {string|null|undefined} tabId
 * @returns {number}
 */
export function tabHeaderDomIndex(sortedHeaders, tabId) {
	if (!tabId) {
		return 0;
	}
	for (var hi = 0; hi < sortedHeaders.length; hi++) {
		if (sortedHeaders[hi].tabId === tabId) {
			return hi;
		}
	}
	return 0;
}
